
function normalizeSlash(s) {
    if (!s) return '/';
    if (s[0] !== '/') s = '/' + s;
    if (!s.endsWith('/')) s += '/';
    return s;
}

// wpconfig.runtime.js (또는 해당 파일)
export function getBasePath() {
    try {
        const raw = (window?.rmVars?.siteSlug ?? '').trim(); // 예: "/scholar/" 또는 "https://.../scholar/"
        if (!raw) return '/scholar';

        // 1) 절대 URL이면 pathname만 추출
        if (/^https?:\/\//i.test(raw)) {
            const pn = new URL(raw).pathname || '/';
            return pn.replace(/\/+$/,'') || '/'; // 끝 슬래시 제거 → "/scholar"
        }

        // 2) 상대 경로면 선행 슬래시 보장 + 끝 슬래시 제거
        return ('/' + raw).replace(/\/{2,}/g,'/').replace(/\/+$/,''); // "/scholar"
    } catch {
        return '/scholar';
    }
}
